module.exports = __webpack_public_path__ + "images/standaard-icon-90x60.0e5e0ec6904aa35363a5.png";